import axios from "axios";
import { Credentials } from "@/./models/credentials.model";
import { BaseService } from "./base.service";
// import { Observable, from} from "rxjs";

class AuthService extends BaseService {

    private static instance: AuthService;

    constructor() {
        super();
        // this.customApi = "https://localhost:44314/api/";
    }

    public static get Instance() {
       //Do you need arguments? Make it a regular method instead.
       return this.instance || (this.instance = new this());
    }

    // public login(credentials: Credentials): any {
    //     return from(axios.post(`${this.api}Auth/login`, credentials));
    //     // .map((res: any) => res.data.auth_token)
    //     // .catch((error: any) => this.handleError(error.response));
    // }

    public login(credentials: Credentials): any {
        return axios.post(`${this.api}Authentication/Authenticate`, credentials);
        // .map((res: any) => res.data.auth_token)
        // .catch((error: any) => this.handleError(error.response));
    }

    public refresh(refreshToken: string, accessToken: string) {
        return axios.post(`${this.api}authentication/refresh`, { refreshToken: refreshToken, accessToken: accessToken })
    }
}
// export a singleton instance in the global namespace
 export const authService = AuthService.Instance;